import { SendByType } from "../enums";

export class SendByLookup {

    static getLookup(): any[] {
        return [
            { label: 'SMS', value: SendByType.SMS },
            { label: 'WhatsApp', value: SendByType.WhatsApp },
        ];
    }
}